import React, { useEffect } from "react";
import { CardComponent, TableComponent } from '../../../components/pages/index';

const PurchInvt = (props) => {
    useEffect(() => {
    }, []);

    const MostrarData = () => {
        return (
            <div className="pt-3">
                <CardComponent header={<h4 className="">Consumo Inventario </h4>} footer={null}>
                    <div className="bg-white">
                        <div>
                        </div>
                        <TableComponent
                            keyField="work_order_id"
                            columns={props.tbColumnsVta}
                            headItem={props.tbHeadingsVta}
                            data={props.tbDataVta}
                            pending={props.tbPendingVta}
                            highlightOnHover={true}
                        />
                    </div>
{/* 
                    {editModal} */}
                </CardComponent>
            </div>
        )
    }

    /* const editModal = showEditModal ? (<PurchInvtModal closeModal={closeEditModal} companyId={props.companySelected} category_id={props.categorySelected} sell_point_id={props.sellPointIdSelected} atributes={props.atributesSelected} measurements={props.measurementSelected}></PurchInvtModal>) : null;
     */return (
        <div>
            <MostrarData />
        </div>
    )
}
export default PurchInvt